import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const PrecisionArtistry = () => {
  const [scrollY, setScrollY] = useState(0);
  const [activeTab, setActiveTab] = useState("technical");

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 1024) {
        setScrollY(window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const technicalCredentials = [
    { icon: "Plane", title: "KCAA Certified", description: "Licensed commercial drone pilot with advanced aerial cinematography expertise and safety protocols." },
    { icon: "Camera", title: "Canon Cinematography", description: "Mastered the Canon  for cinematic shoots using manual lenses and gimbal work." },
    { icon: "Zap", title: "Advanced Lighting Systems", description: "Proficient in ARRI, Aputure, and custom LED lighting setups for any environment." },
    { icon: "Settings", title: "Post-Production Excellence", description: "Expert-level color grading, sound design, and visual effects using industry-standard tools i.e. Adobe Suite." },
  ];

  const creativePhilosophy = [
    { icon: "Eye", title: "Visual Storytelling", description: "Every frame serves the narrative, creating emotional connections that drive business outcomes." },
    { icon: "Lightbulb", title: "Innovation Focus", description: "Constantly exploring new techniques and technologies to push creative boundaries." },
    { icon: "Users", title: "Collaborative Approach", description: "Working closely with clients to understand their vision and exceed expectations." },
    { icon: "Award", title: "Excellence Standard", description: "Committed to delivering work that stands the test of time and elevates brand perception." },
  ];

  const currentContent =
    activeTab === "technical" ? technicalCredentials : creativePhilosophy;

  return (
    <section data-theme="light" className="relative overflow-hidden  py-4 sm:py-16 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">

          {/* CONTENT */}
          <div
            className="space-y-8 lg:space-y-10"
            style={{
              transform: window.innerWidth >= 1024
                ? `translateY(${scrollY * 0.1}px)`
                : "none",
            }}

          >
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4">
                Precision <span className="text-red-700">Meets</span> Artistry
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-text-secondary max-w-xl">
                Engineering precision meets visionary creativity — delivering cinematic excellence that drives your brand forward.
              </p>
            </div>

            {/* Tabs */}
            <div className="flex flex-wrap gap-3">
              {["technical", "creative"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-5 py-2 rounded-lg text-xs sm:text-sm md:text-lg font-semibold transition ${activeTab === tab
                      ? "bg-red-600 text-white shadow"
                      : "bg-white text-black border hover:bg-red-50"
                    }`}
                >
                  {tab === "technical" ? "Technical Mastery" : "Creative Philosophy"}
                </button>
              ))}
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {currentContent.map((item, index) => (
                <div key={index} className="bg-white p-5 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-red-100 rounded-lg hidden sm:flex items-center justify-center mb-3">
                    <Icon name={item.icon} size={20} color="red" />
                  </div>
                  <h3 className="font-semibold text-red-700 text-base sm:text-lg mb-1">{item.title}</h3>
                  <p className="text-sm text-text-secondary">{item.description}</p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Link
              to="/studio-universe-about"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 bg-red-700 text-white text-sm font-semibold rounded-lg"
            >
              Learn More About Our Process
              <Icon name="ArrowRight" size={18} />
            </Link>
          </div>

          {/* IMAGE */}
          <div
            className="relative hidden lg:flex items-stretch"
            style={{ transform: `translateY(${scrollY * -0.03}px)` }}
          >
            <div className="relative w-full rounded-2xl overflow-hidden shadow-premium min-h-[320px] sm:min-h-[420px] lg:min-h-full">
              <Image
                src="/assets/images/hero/denis.jpg"
                alt="Professional cinematographer"
                className="w-full h-full object-cover"
                width={900}
                height={1200}
              />
            </div>


            {/* Floating Stats Cards */}
            <div className="absolute -top-8 -right-8 bg-white p-6 rounded-xl shadow-elevation">
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-1">4K</div>
                <div className="text-sm text-text-secondary">Resolution</div>
              </div>
            </div>

            <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-elevation">
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-1">50+</div>
                <div className="text-sm text-text-secondary">Projects</div>
              </div>
            </div>

            {/* Equipment Showcase */}
            <div className="absolute top-1/2 -right-12 transform -translate-y-1/2">
              <div className="bg-primary p-4 rounded-xl shadow-elevation">
                <div className="flex flex-col items-center text-white">
                  <Icon
                    name="Camera"
                    size={32}
                    color="#D4AF37"
                    strokeWidth={1.5}
                  />
                  <div className="text-xs mt-2 text-center">
                    <div className="font-semibold">R6</div>
                    <div className="opacity-80">6K Cinema</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default PrecisionArtistry;
